import { useState } from 'react';
import { CustomDialogProps } from '@/dashboard/components/Dialog/index';
import LogoLoading from '@/dashboard/components/loading/LogoLoading';
import PolicyModel from '@/dashboard/models/policys/PolicyModel';
import { usePolicyStore } from '@/dashboard/store/PolicyStore';
import { XCircleIcon } from '@heroicons/react/outline';
import { apiCancelPausePolicy, convertTimeToServerStoredTimeData } from '@jove-frontend/uikit';
import { LoadingButton } from '@mui/lab';
import { Box, Button, Typography } from '@mui/material';
import toast from 'react-hot-toast';

type CancelPolicyDialogConfirmProps = CustomDialogProps & {
  policy: PolicyModel;
  close?: () => void;
};

const CancelPolicyDialogConfirm = (props: CancelPolicyDialogConfirmProps) => {
  const { policy, close } = props;
  const [loading, setLoading] = useState(false);
  const [{ fetchPolicies }] = usePolicyStore(({ actions }) => [actions]);

  /**
   * request
   */
  const requestCancelPause = async () => {
    const params = {
      pause_id: policy?.pauses?.[0]?.id,
      pause_end_date: convertTimeToServerStoredTimeData(new Date()),
    };

    setLoading(true);
    const [res] = await apiCancelPausePolicy(params);
    setLoading(false);
    if (res) {
      fetchPolicies();
      toast.success('Cancel pause success!');
      closeAction();
    }
  };

  /**
   * methods
   */
  const closeAction = () => {
    close?.();
  };

  return (
    <Box className="relative mt-4 flex flex-col items-center">
      {loading && <LogoLoading />}
      <Box className="bg-brand-secondary/20 text-brand-secondary rounded-full p-2">
        <XCircleIcon className="h-7 w-7" />
      </Box>
      <Typography className="text-black-secondary mt-4 text-center font-black" variant="h5">
        Cancel your future pause
      </Typography>
      <Typography className="text-black-secondary mt-2 text-center font-medium" variant="subtitle1">
        You will get back on premium.
      </Typography>
      <Box className="mt-6 flex w-full flex-row justify-end">
        <Button className="text-brand-primary text-lg font-bold" variant="text" onClick={closeAction}>
          Keep pausing
        </Button>
        <LoadingButton className="ml-2 h-12 w-[190px] rounded-full text-lg font-bold" loading={loading} loadingIndicator="Loading..." color="primary" onClick={requestCancelPause} variant="contained">
          <span>Cancel pause</span>
        </LoadingButton>
      </Box>
    </Box>
  );
};

export default CancelPolicyDialogConfirm;
